import { render, staticRenderFns } from "./CompanyManagerView.vue?vue&type=template&id=2ebeb0af&scoped=true"
import script from "./CompanyManagerView.vue?vue&type=script&lang=js"
export * from "./CompanyManagerView.vue?vue&type=script&lang=js"
import style0 from "./CompanyManagerView.vue?vue&type=style&index=0&id=2ebeb0af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebeb0af",
  null
  
)

export default component.exports